import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Search from 'pages/parts/Search'
import DeleteModal from 'pages/parts/DeleteModal'
import { GET, DELETE, POST, PUT } from 'helpers/api'
import { toast } from "react-toastify"
import { Modal } from "react-bootstrap"
import { formatDate, formatDateWithTime } from "helpers/helpers"


function Index() {
	const URL = "/services/web/api/bonus-by-point/bonus-scales"
	const { t } = useTranslation()

	const [modalDelete, setModalDelete] = useState(false)
	const [OpenModal, setOpenModal] = useState(false)
	const [OpenModalEdit, setOpenModalEdit] = useState(false)
	const [IsActive, setIsActive] = useState(true)
	const [activeTab, setActiveTab] = useState('diagram');
	const [sendData, setSendData] = useState({
		name: '',
		minAmount: null,
		maxAmount: null,
		bonusPercent: null
	})

	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [data, setData] = useState([])

	async function getData() {
		const response = await GET(URL)
		if (response) {
			setData(response)
			console.log(data)
		}
	}




	async function deleteItem() {
		const response = await DELETE(`/services/web/api/bonus-by-point/bonus-scales/${deleteModalParams.id}`, {}, { loader: true })
		if (response) {
			getData()
			setModalDelete(false)
		}
	}

	async function search(data, searchValue) {
		setData(data);
	}

	useEffect(() => {
		getData()
	}, [])

	const handleCloseModalClick = () => {
		setSendData({
			name: '',
			minAmount: null,
			maxAmount: null,
			bonusPercent: null
		})
		setOpenModal(false)
		setOpenModalEdit(false)
	};

	const handleNumberChange = (event, status) => {
		const rawValue = event.target.value;
	
		if (/^\d*$/.test(rawValue)) { // Faqat raqamlar yoki bo'sh satr
			const parsedValue = rawValue === '' ? null : Number(rawValue);
	
			if (status === 'start') {
				setSendData({ ...sendData, minAmount: parsedValue });
			} else if (status === 'end') {
				setSendData({ ...sendData, maxAmount: parsedValue });
			}
		}
	};
	

	function hasOverlappingRange(newBonus) {
		const newMin = newBonus.minAmount !== null ? Number(newBonus.minAmount) : 0;
		const newMax = newBonus.maxAmount !== null ? Number(newBonus.maxAmount) : Infinity;
	
		return data.some(existing => {
			if (existing.isActive !== true) return false; // ✅ faqat faol bonuslar
			// if (existing.id === newBonus.id) return false; // update rejimi uchun
	
			const existingMin = existing.minAmount !== null ? Number(existing.minAmount) : 0;
			const existingMax = existing.maxAmount !== null ? Number(existing.maxAmount) : Infinity;
	
			// 🔥 Kesishuv borligini aniqlash: [existingMin, existingMax] ∩ [newMin, newMax]
			return existingMin <= newMax && newMin <= existingMax;
		});
	}
	




	const isButtonDisabled = !(sendData?.bonusPercent > 0 && sendData?.name && (sendData?.minAmount > 0 || sendData?.maxAmount > 0));

	function CreateBonus() {
		console.log(sendData);

		if (sendData.maxAmount !== null && sendData.maxAmount < sendData.minAmount) {
			toast.warn(t('WARN_LOYALTY'));
			return;
		}
		if (hasOverlappingRange(sendData)) {
			const confirmOverlap = window.confirm(t('LOYALTY_ACCEPT'));
			if (!confirmOverlap) return;
		}
		if (sendData.minAmount == null) {
			sendData.minAmount = 0
		}
		POST('/services/web/api/bonus-by-point/bonus-scales', sendData, { loader: true })
			.then(res => {
				console.log(res);
				setTimeout(() => {
					toast.success(t('SENDED'));
					handleCloseModalClick();
					getData();
				}, 500);
			})
			.catch(err => {
				console.error(err);
				toast.error(t('ERROR'));
			});
	}

	function EditBonus() {
		if (sendData.maxAmount !== null && sendData.maxAmount < sendData.minAmount) {
			toast.error(t("Maksimal miqdor minimal miqdordan kichik bo'lishi mumkin emas."));
			return;
		}
		if (hasOverlappingRange(sendData)) {
			const confirmOverlap = window.confirm(t('Bu oraliqdagi faol bonus mavjud. Baribir yaratmoqchimisiz?'));
			if (!confirmOverlap) return;
		}
		if (sendData.minAmount == null) {
			sendData.minAmount = 0
		}
		const response = PUT(`/services/web/api/bonus-by-point/bonus-scales/${sendData.id}`, sendData, { loader: true })
			.then(res => {
				handleCloseModalClick()
				getData()
			}).catch(err => {
				console.log(err);
			})
	}

	function handleEdit(item) {
		setSendData({
			name: item.name,
			minAmount: item.minAmount,
			maxAmount: item.maxAmount,
			bonusPercent: item.bonusPercent,
			id: item.id
		})
		setOpenModalEdit(true)
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('LOYALTY_MENU')}
				</h4>
				<div className="d-flex">
					<button onClick={(_) => setOpenModal(true)} className="btn-rounded btn btn-primary" >
						<i className="uil uil-plus me-2"></i>
						{t('CREATE')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
				<div className="alert alert-primary	 d-block my-3">
						<div>
							1) {t("LOYALTY_INFO1")} <span className="required-mark">*</span>
						</div>
						<div>
							2) {t("LOYALTY_INFO2")} <span className="required-mark">*</span>
						</div>
						{/* <div>
							3) {t("LOYALTY_INFO3")} <span className="required-mark">*</span>
						</div> */}
						<div>
							3) {t("LOYALTY_INFO4")} <span className="required-mark">*</span>
						</div>
					</div>


					<div className="d-flex mb-3 justify-content-between">
						<div className="me-2">
							<Search url={URL} search={search} getData={getData}></Search>
						</div>
						<div className="btn-group  bg-light " role="group">
							<button
								type="button"
								className={`btn ${IsActive ? 'btn-primary' : 'btn-light'}`}
								onClick={() => {
									setIsActive(true)
								}}
							>
								{t("ACTIVE")}
							</button>
							<button
								type="button"
								className={`btn ${!IsActive ? 'btn-primary' : 'btn-light'}`}
								onClick={() => {
									setIsActive(false)
								}}
							>
								{t('OFF_BONUS')}
							</button>
						</div>
					</div>


					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th>{t('NAME2')}</th>
									<th>{t('MIN_AMOUNT_FOR_BONUS')}</th>
									<th>{t('MAX_AMOUNT_FOR_BONUS')}</th>
									<th>{t('DATE')}</th>
									<th className="text-center">{t('PERCENTAGE')}</th>
									{IsActive &&
										<th className="text-center table-control">
											{t('ACTION')}
										</th>
									}
								</tr>
							</thead>
							<tbody>
								{data.length > 0 ? data?.map((item, index) => {
									return item.isActive == IsActive ? <tr key={index}>
										<td>{item.name}</td>
										<td>{item.minAmount}</td>
										<td>{item.maxAmount}</td>
										<td>{formatDate(item.createdAt)}</td>
										<td className="text-center">
											{item.bonusPercent} %
										</td>
										{IsActive &&
											<td className="d-flex justify-content-center">
												<div onClick={() => handleEdit(item)} className="table-action-button table-action-primary-button me-2">
													<i className="uil-edit-alt"></i>
												</div>
												<div className="table-action-button table-action-danger-button"
													onClick={() => {
														setDeleteModalParams({ id: item.id, index: index });
														setModalDelete(true)
													}}>
													<i className="uil-times"></i>
												</div>
											</td>
										}
									</tr> : <></>
								}) : <tr>
									<td colSpan={12} align="center">Ma'lumot yo'q</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<Modal show={OpenModal} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={handleCloseModalClick}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t(`CREATE`)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="d-flex gap-3">
					<div className="form-group w-100 mb-2 d-grid gap-3">
						<div>
							<label>{t('NAME2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" value={sendData?.name} onChange={(e) => setSendData({ ...sendData, name: e.target.value })} placeholder={t('')}
								autoFocus />
						</div>

						<div>
							<label>{t('MIN_AMOUNT_FOR_BONUS')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={sendData?.minAmount} placeholder={t('')} onChange={(e) => handleNumberChange(e, 'start')}
							/>
						</div>

						<div>
							<label>{t('MAX_AMOUNT_FOR_BONUS')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={sendData?.maxAmount} placeholder={t('')} onChange={(e) => handleNumberChange(e, 'end')}
							/>
						</div>
						<div>
							<label>{t('PERCENTAGE')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={sendData?.bonusPercent} onChange={(e) => setSendData({ ...sendData, bonusPercent: e.target.value })} placeholder={t('')}
							/>
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={handleCloseModalClick}>{t('CANCEL')}</button>
							<button type="button" className="btn btn-primary w-100" onClick={CreateBonus} disabled={isButtonDisabled}>{t('ADD')}</button>
						</div>

					</div>
				</Modal.Body>
			</Modal>

			<Modal show={OpenModalEdit} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={handleCloseModalClick}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t(`EDIT`)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="d-flex gap-3">
					<div className="form-group w-100 mb-2 d-grid gap-3">
						<div>
							<label>{t('NAME2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" value={sendData?.name} onChange={(e) => setSendData({ ...sendData, name: e.target.value })} placeholder={t('')}
								autoFocus />
						</div>

						<div>
							<label>{t('MIN_AMOUNT_FOR_BONUS')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={sendData?.minAmount} placeholder={t('')} onChange={(e) => handleNumberChange(e, 'start')}
							/>
						</div>

						<div>
							<label>{t('MAX_AMOUNT_FOR_BONUS')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={sendData?.maxAmount} placeholder={t('')} onChange={(e) => handleNumberChange(e, 'end')}
							/>
						</div>
						<div>
							<label>{t('PERCENTAGE')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={sendData?.bonusPercent} onChange={(e) => setSendData({ ...sendData, bonusPercent: e.target.value })} placeholder={t('')}
							/>
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={handleCloseModalClick}>{t('CANCEL')}</button>
							<button type="button" className="btn btn-primary w-100" onClick={EditBonus} disabled={isButtonDisabled}>{t('EDIT')}</button>
						</div>

					</div>
				</Modal.Body>
			</Modal>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

		</>
	)
}

export default Index
